import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { mostrarModulo } from "../../redux/actions/actGlobal";
import Menu from './Menu';
import Cargando from "./app/Cargando";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import NotificationsIcon from '@material-ui/icons/Notifications';
import AssignmentIcon from '@material-ui/icons/Assignment';
import PaymentIcon from '@material-ui/icons/Payment';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Dialog, DialogContent } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { coloresEmma, consulta, valor_peso } from "../../global/js/funciones";
import emma_zoom from "../../global/imagenes/emma_zoom.png";
import PintarEncuestaGenero from './encuesta_genero/PintarEncuestaGenero'
import Politica from "./Politica.js";
import InicioSidebarApps from "./InicioSidebarApps";
import { InicioAppsProvider } from "./InicioAppsContext";
import InicioAppsGridMovil from "./InicioAppsGridMovil";
import { PROCESOS_ACADEMICOS, PROCESOS_FINANCIEROS, SERVICIOS} from "./Helper";
import AppBarModal from './AppBarModal';

const MOBILE_BREAKPOINT = 768;

function formatoValorPagoDetalle(raw) {
  if (raw == null || raw === '') return valor_peso(0);
  if (typeof raw === 'number' && Number.isFinite(raw)) return valor_peso(raw);
  const s = String(raw).trim().replace(/\s/g, '');
  if (/^\d{1,3}(\.\d{3})+,\d{1,4}$/.test(s)) {
    return valor_peso(Number.parseFloat(s.replace(/\./g, '').replace(',', '.')) || 0);
  }
  if (/^\d{1,3}(\.\d{3})+$/.test(s)) {
    return valor_peso(Number.parseFloat(s.replace(/\./g, '')) || 0);
  }
  const n = Number(s.replace(',', '.'));
  return valor_peso(Number.isFinite(n) ? n : 0);
}

class Inicio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mostrar_encuesta: false,
      indiceServicios: 0,
      itemsServiciosPorPagina: 3,
      isMobile: typeof window !== 'undefined' && window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches,
      moduloExpandido: null,
      pagos: [],
      pagosPendientesTotal: 0,
      pagosPagadosTotal: 0,
      modalPagos: false,
      cargandoPagos: false,
      solicitudesAcademicas: [],
      solicitudesAcademicasTotal: 0,
      modalSolicitudesAcademicas: false,
      cargandoSolicitudesAcademicas: false,
      modulosPorHelper: {
        academico: [],
        financiero: [],
        servicios: [],
      },
      titulosModulos: {
        academico: '',
        financiero: '',
        servicios: '',
      },
    };
  }

  componentDidMount() {
    const { mostrarModulo } = this.props;
    mostrarModulo({ ruta: '/', nombre: 'inicio' });
    this.validar_encuesta_genero();
    this.cargarConfiguracionModulos();
    this.cargarResumenPagos();
    this.cargarResumenSolicitudesAcademicas();
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const handler = (e) => this.setState({ isMobile: e.matches, moduloExpandido: e.matches ? this.state.moduloExpandido : null });
    mq.addListener(handler);
    this._mqCleanup = () => mq.removeListener(handler);
  }

  componentWillUnmount() {
    if (this._mqCleanup) this._mqCleanup();
  }

  toggleModulo = (modulo) => {
    this.setState((prev) => ({
      moduloExpandido: prev.moduloExpandido === modulo ? null : modulo,
    }));
  };

  componentDidUpdate(prevProps) {
    const prevSearch = prevProps.location?.search || "";
    const currentSearch = this.props.location?.search || "";

    if (prevSearch !== currentSearch) {
      this.setState({ indiceServicios: 0 });
    }
  }

  convertir = (dato) => {
    return `${dato || ""}`
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  };

  getDatoBuscar = () => {
    const search = this.props.location?.search || "";
    return new URLSearchParams(search).get("q") || "";
  };

  getNombreUsuario = () => {
    const { usuario } = this.props;

    if (!usuario) return "";

    const nombreBase = `${usuario.primer_nombre || ""} ${usuario.primer_apellido || ""}`.trim();

    if (nombreBase) {
      return nombreBase.split(" ")[0];
    }

    if (usuario.nombre) {
      return `${usuario.nombre}`.split(" ")[0];
    }

    return "";
  };

  buscar = (dato_buscar) => {
    const { actividades } = this.props;
    const q = this.convertir(dato_buscar);

    if (!q) return actividades || [];

    return (actividades || []).filter((data) =>
      this.convertir(data?.nombre).includes(q)
    );
  };

  validar_encuesta_genero = () => {
    const { usuario } = this.props;

    if (usuario) {
      consulta(
        'api/v1.0/personas/validar_encuesta_genero',
        { id_persona: usuario.id },
        'post',
        (error, estado) => {
          if (estado === 404 && usuario?.perfil?.codigo === 'Per_Nor') {
            this.setState({ mostrar_encuesta: true });
          }
        }
      );
    }
  };

  cargarConfiguracionModulos = async () => {
    const obtenerPermisosPorHelper = (helperId) => new Promise((resolve) => {
      consulta(
        `api/v1.0/valores/permisos?principal=${helperId}`,
        null,
        null,
        (error, estado, resp) => {
          if (error || estado >= 400 || !Array.isArray(resp)) {
            resolve([]);
            return;
          }
          resolve(resp);
        },
        false
      );
    });

    try {
      const [academicoPermisos, financieroPermisos, serviciosPermisos] = await Promise.all([
        obtenerPermisosPorHelper(PROCESOS_ACADEMICOS),
        obtenerPermisosPorHelper(PROCESOS_FINANCIEROS),
        obtenerPermisosPorHelper(SERVICIOS),
      ]);

      this.setState({
        modulosPorHelper: {
          academico: academicoPermisos.map((x) => x?.secundario?.codigo).filter(Boolean),
          financiero: financieroPermisos.map((x) => x?.secundario?.codigo).filter(Boolean),
          servicios: serviciosPermisos.map((x) => x?.secundario?.codigo).filter(Boolean),
        },
        titulosModulos: {
          academico: academicoPermisos[0]?.principal?.nombre || '',
          financiero: financieroPermisos[0]?.principal?.nombre || '',
          servicios: serviciosPermisos[0]?.principal?.nombre || '',
        },
      });
    } catch (e) {}
  };

  dividirModulos = (actividades = [], esSubmodulo = false) => {
    if (esSubmodulo) {
      return {
        academico: actividades || [],
        financiero: [],
        masServicios: [],
      };
    }

    const { modulosPorHelper } = this.state;
    const academico = [];
    const financiero = [];
    const masServicios = [];

    (actividades || []).forEach((actividad) => {
      const codigo = actividad?.codigo;
      if (modulosPorHelper.academico.includes(codigo)) academico.push(actividad);
      else if (modulosPorHelper.financiero.includes(codigo)) financiero.push(actividad);
      else if (modulosPorHelper.servicios.includes(codigo)) masServicios.push(actividad);
    });

    return { academico, financiero, masServicios };
  };

  moverServiciosDerecha = (total) => {
    this.setState((prevState) => {
      const paso = prevState.itemsServiciosPorPagina || 3;
      const nuevoIndice = prevState.indiceServicios + paso;
      if (nuevoIndice >= total) return prevState;
      return { indiceServicios: nuevoIndice };
    });
  };

  moverServiciosIzquierda = () => {
    this.setState((prevState) => {
      const paso = prevState.itemsServiciosPorPagina || 3;
      return { indiceServicios: Math.max(prevState.indiceServicios - paso, 0) };
    });
  };

  cargarResumenPagos = () => {
    this.setState({ cargandoPagos: true });
    consulta('api/v1.0/consultas/pagosPendientes', null, null, (error, estado, resp) => {
      if (error || estado >= 400 || !resp) {
        this.setState({ cargandoPagos: false });
        return;
      }
      const pagos = resp.pagos_pendientes || [];
      const pagosPendientesTotal = pagos.filter((pago) => `${pago.est_pago || ''}`.toLowerCase() === 'sin pago').length;
      const pagosPagadosTotal = pagos.filter((pago) => `${pago.est_pago || ''}`.toLowerCase() === 'pagada').length;
      this.setState({ pagos, pagosPendientesTotal, pagosPagadosTotal, cargandoPagos: false });
    });
  };

  abrirModalPagos = () => {
    this.setState({ modalPagos: true });
  };

  cerrarModalPagos = () => {
    this.setState({ modalPagos: false });
  };

  cargarResumenSolicitudesAcademicas = () => {
    this.setState({ cargandoSolicitudesAcademicas: true });
    consulta('api/v1.0/consultas/solicitudesAcademicas', null, null, (error, estado, resp) => {
      if (error || estado >= 400 || !resp) {
        this.setState({ cargandoSolicitudesAcademicas: false });
        return;
      }
      const solicitudesAcademicas = resp.solicitudes || [];
      this.setState({
        solicitudesAcademicas,
        solicitudesAcademicasTotal: solicitudesAcademicas.length,
        cargandoSolicitudesAcademicas: false
      });
    });
  };

  abrirModalSolicitudesAcademicas = () => {
    this.setState({ modalSolicitudesAcademicas: true });
  };

  cerrarModalSolicitudesAcademicas = () => {
    this.setState({ modalSolicitudesAcademicas: false });
  };

  renderBloque = (titulo, items, submodulo, tipo = 'academico') => {
    if (!items || !items.length) return null;

    const { isMobile, moduloExpandido } = this.state;
    const sectionKey = tipo;
    const isExpanded = !isMobile || moduloExpandido === sectionKey;
    const sectionClass = [
      'inicio-section-card',
      tipo === 'academico' ? 'inicio-section-academico' : 'inicio-section-financiero',
      submodulo ? 'inicio-section-submodulo' : '',
      isMobile ? 'inicio-section-mobile-accordion' : '',
      !isExpanded ? 'inicio-section-collapsed' : '',
    ].filter(Boolean).join(' ');

    return (
      <div className={sectionClass}>
        <h2
          className="inicio-section-title"
          onClick={isMobile ? () => this.toggleModulo(sectionKey) : undefined}
          role={isMobile ? 'button' : undefined}
          aria-expanded={isMobile ? isExpanded : undefined}
        >
          {titulo}
          {isMobile && <ExpandMoreIcon className="inicio-section-expand-icon" style={{ fontSize: 20 }} />}
        </h2>

        <div className="inicio-section-content" style={{ width: '100%' }}>
          <Menu actividades={items} submodulo={submodulo} tipo={tipo} />
        </div>
      </div>
    );
  };

  renderBloqueServicios = (titulo, items, submodulo) => {
    if (!items || !items.length) return null;

    const { indiceServicios, itemsServiciosPorPagina, isMobile, moduloExpandido } = this.state;
    const sectionKey = 'servicios';
    const isExpanded = !isMobile || moduloExpandido === sectionKey;
    const paso = itemsServiciosPorPagina || 3;
    const visibles = items.slice(indiceServicios, indiceServicios + paso);

    const puedeIzquierda = indiceServicios > 0;
    const puedeDerecha = indiceServicios + paso < items.length;

    const sectionClass = [
      'inicio-section-card',
      'inicio-section-servicios',
      submodulo ? 'inicio-section-submodulo' : '',
      isMobile ? 'inicio-section-mobile-accordion' : '',
      !isExpanded ? 'inicio-section-collapsed' : '',
    ].filter(Boolean).join(' ');

    return (
      <div className={sectionClass}>
        <h2
          className="inicio-section-title"
          onClick={isMobile ? () => this.toggleModulo(sectionKey) : undefined}
          role={isMobile ? 'button' : undefined}
          aria-expanded={isMobile ? isExpanded : undefined}
        >
          {titulo}
          {isMobile && <ExpandMoreIcon className="inicio-section-expand-icon" style={{ fontSize: 20 }} />}
        </h2>

        <div
          className="inicio-section-content"
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}
        >
          <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
            <button
              type="button"
              onClick={this.moverServiciosIzquierda}
              disabled={!puedeIzquierda}
              style={{
                width: '30px',
                height: '30px',
                minWidth: '30px',
                borderRadius: '50%',
                border: '1px solid #d1d5db',
                background: puedeIzquierda ? '#ffffff' : '#f3f4f6',
                color: '#111827',
                cursor: puedeIzquierda ? 'pointer' : 'not-allowed',
                fontSize: '16px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              ‹
            </button>
          </div>

          <div style={{ flex: 1, minWidth: 0 }}>
            <Menu actividades={visibles} submodulo={submodulo} tipo="servicios" />
          </div>

          <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
            <button
              type="button"
              onClick={() => this.moverServiciosDerecha(items.length)}
              disabled={!puedeDerecha}
              style={{
                width: '30px',
                height: '30px',
                minWidth: '30px',
                borderRadius: '50%',
                border: '1px solid #d1d5db',
                background: puedeDerecha ? '#ffffff' : '#f3f4f6',
                color: '#111827',
                cursor: puedeDerecha ? 'pointer' : 'not-allowed',
                fontSize: '16px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              ›
            </button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { cargandoMenu, submodulo, usuario } = this.props;
    const {
      mostrar_encuesta,
      pagos,
      pagosPendientesTotal,
      pagosPagadosTotal,
      modalPagos,
      cargandoPagos,
      solicitudesAcademicas,
      solicitudesAcademicasTotal,
      modalSolicitudesAcademicas,
      cargandoSolicitudesAcademicas,
      titulosModulos,
    } = this.state;

    const dato_buscar = this.getDatoBuscar();
    const actividadesFiltradas = this.buscar(dato_buscar);
    const { academico, financiero, masServicios } = this.dividirModulos(actividadesFiltradas, submodulo);
    const tituloAcademico = titulosModulos.academico || (submodulo ? 'Submódulos' : '');

    const nombreSaludo = this.getNombreUsuario() || "Estudiante";
    const ahora = new Date();
    const semestreActual = `Semestre ${ahora.getFullYear()}-${ahora.getMonth() < 6 ? 1 : 2}`;

    const pagosOrdenados = [...pagos].sort((a, b) => {
      const estadoA = `${a.est_pago || ''}`.toLowerCase();
      const estadoB = `${b.est_pago || ''}`.toLowerCase();
      if (estadoA === estadoB) return 0;
      if (estadoA === 'sin pago') return -1;
      if (estadoB === 'sin pago') return 1;
      return 0;
    });

    const appsContextActivo = !cargandoMenu && !mostrar_encuesta;

    return (
      <div className="contenedor_menu inicio-contenedor inicio-principal" style={{ height: '100vh' }}>
        <InicioAppsProvider activo={appsContextActivo} perfilCodigo={usuario?.perfil?.codigo || ''}>
        {cargandoMenu ? (
          <Cargando marginTop="100px" />
        ) : (
          <>
            {mostrar_encuesta ? (
              <PintarEncuestaGenero
                mostrar_encuesta={mostrar_encuesta}
                setMostrarEncuesta={(nuevoValor) =>
                  this.setState({ mostrar_encuesta: nuevoValor })
                }
              />
            ) : (
              <>
                {submodulo && (
                  <div
                    className="TituloInicio2 TituloInicio2-submodulo"
                    style={{
                      display: 'flex',
                      alignSelf: 'flex-start',
                      marginBottom: '8px'
                    }}
                  >
                    <Link to="/">
                      <ArrowBackIcon
                        style={{
                          fontSize: '35px',
                          color: coloresEmma.secondarycolor,
                          marginTop: '5px'
                        }}
                      />
                    </Link>
                  </div>
                )}

                <div
                  className={`inicio-wrapper ${submodulo ? 'inicio-wrapper-submodulo' : ''}`}
                  style={{
                    paddingTop: 0,
                    paddingLeft: 0,
                    paddingRight: 0,
                    width: '100%',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flex: 1,
                    minHeight: 0
                  }}
                >
                  <div
                    className={`inicio-layout ${submodulo ? 'inicio-layout-submodulo' : ''}`}
                  >
                    <div className="inicio-saludo-secciones-escala">
                      {!submodulo && (
                        <>
                          <div className="inicio-zona-hola">
                            <div className="inicio-header-unificado">
                              <div className="inicio-header-main">
                                <div className="inicio-avatar">
                                  <img src={emma_zoom} alt="Emma" />
                                </div>
                                <div className="inicio-header-text">
                                  <div className="inicio-saludo">
                                    Hola, <span>{nombreSaludo}</span><span className="inicio-saludo-exclamacion">!</span>
                                  </div>
                                  <div className="inicio-semestre">
                                    {semestreActual}
                                  </div>
                                </div>
                              </div>
                              <div className="inicio-summary-row">
                                <div className="inicio-summary-card inicio-summary-notif-oculto">
                                  <div className="inicio-summary-icon inicio-summary-icon-notif">
                                    <NotificationsIcon style={{ fontSize: 24 }} />
                                  </div>
                                  <div className="inicio-summary-text">
                                    <div className="inicio-summary-main inicio-summary-main-red">{academico.length} Notificaciones</div>
                                    <div className="inicio-summary-sub">20 leídas</div>
                                  </div>
                                </div>
                                <div
                                  className="inicio-summary-card"
                                  style={{ cursor: 'pointer' }}
                                  onClick={this.abrirModalSolicitudesAcademicas}
                                >
                                  <div className="inicio-summary-icon inicio-summary-icon-proceso">
                                    <AssignmentIcon style={{ fontSize: 24 }} />
                                  </div>
                                  <div className="inicio-summary-text">
                                    <div className="inicio-summary-main">
                                      {cargandoSolicitudesAcademicas ? 'Cargando solicitudes...' : `${solicitudesAcademicasTotal} Procesos realizados`}
                                    </div>
                                    <div className="inicio-summary-sub">Ver detalle de solicitudes</div>
                                  </div>
                                </div>
                                <div
                                  className="inicio-summary-card"
                                  style={{ cursor: 'pointer' }}
                                  onClick={this.abrirModalPagos}
                                >
                                  <div className="inicio-summary-icon inicio-summary-icon-pago">
                                    <PaymentIcon style={{ fontSize: 24 }} />
                                  </div>
                                  <div className="inicio-summary-text">
                                    <div className="inicio-summary-main">{cargandoPagos ? 'Cargando pagos...' : `${pagosPendientesTotal} Pagos pendientes`}</div>
                                    <div className="inicio-summary-sub">{cargandoPagos ? 'Consultando estado...' : `${pagosPagadosTotal} pagos realizados`}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="inicio-sections">
                        {this.renderBloque(tituloAcademico, academico, submodulo, 'academico')}
                        {this.renderBloque(titulosModulos.financiero, financiero, submodulo, 'financiero')}
                        {this.renderBloqueServicios(titulosModulos.servicios, masServicios, submodulo)}
                        {!submodulo ? <InicioAppsGridMovil /> : null}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        )}

        <Politica />
        <Dialog
          open={modalSolicitudesAcademicas}
          onClose={this.cerrarModalSolicitudesAcademicas}
          fullWidth
          maxWidth="sm"
          BackdropProps={{
            className: 'inicio-pagos-modal-backdrop'
          }}
        >
          <AppBarModal titulo="Solicitudes académicas" mostrarModal={this.cerrarModalSolicitudesAcademicas} titulo_accion="" accion="" />
          <DialogContent dividers className="inicio-pagos-modal-content">
            {cargandoSolicitudesAcademicas ? (
              <div className="inicio-pagos-empty-wrap">
                <img src={emma_zoom} alt="" className="inicio-pagos-empty-img" />
                <div className="inicio-pagos-empty">Cargando solicitudes...</div>
              </div>
            ) : solicitudesAcademicas.length ? solicitudesAcademicas.map((solicitud, index) => (
              <div key={`${solicitud.tipo || 'solicitud'}-${index}`} className="inicio-pagos-item">
                <div className="inicio-pagos-item-line"><strong>Tipo:</strong> {solicitud.tipo || 'No disponible'}</div>
                <div className="inicio-pagos-item-line"><strong>Estado:</strong> {solicitud.estado || 'No disponible'}</div>
                <div className="inicio-pagos-item-line"><strong>Fecha:</strong> {solicitud.fecha || 'No disponible'}</div>
              </div>
            )) : (
              <div className="inicio-pagos-empty-wrap">
                <img src={emma_zoom} alt="" className="inicio-pagos-empty-img" />
                <div className="inicio-pagos-empty">No tiene solicitudes académicas registradas.</div>
              </div>
            )}
          </DialogContent>
        </Dialog>
        <Dialog
          open={modalPagos}
          onClose={this.cerrarModalPagos}
          fullWidth
          maxWidth="sm"
          BackdropProps={{
            className: 'inicio-pagos-modal-backdrop',
            style: { backgroundColor: 'rgba(0, 0, 0, 0.82)' }
          }}
        >
          <AppBarModal titulo="Detalle de pagos" mostrarModal={this.cerrarModalPagos} titulo_accion="" accion="" />
          <DialogContent dividers className="inicio-pagos-modal-content">
            {cargandoPagos ? (
              <div className="inicio-pagos-empty-wrap">
                <img src={emma_zoom} alt="" className="inicio-pagos-empty-img" />
                <div className="inicio-pagos-empty">Cargando pagos...</div>
              </div>
            ) : pagosOrdenados.length ? pagosOrdenados.map((pago, index) => (
              <div key={`${pago.num_identificacion || 'pago'}-${index}`} className="inicio-pagos-item">
                <div className="inicio-pagos-item-line"><strong>Tipo de pago:</strong> {pago.nom_concepto || 'No disponible'}</div>
                <div className="inicio-pagos-item-line"><strong>Valor:</strong> {formatoValorPagoDetalle(pago.val_cobros)}</div>
                <div className="inicio-pagos-item-line"><strong>Estado:</strong> {pago.est_pago || 'No disponible'}</div>
              </div>
            )) : (
              <div className="inicio-pagos-empty-wrap">
                <img src={emma_zoom} alt="" className="inicio-pagos-empty-img" />
                <div className="inicio-pagos-empty">No tiene pagos relacionados.</div>
              </div>
            )}
          </DialogContent>
        </Dialog>
        {appsContextActivo ? <InicioSidebarApps /> : null}
        </InicioAppsProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { cargandoMenu, usuario } = state.redGlobal;

  return {
    cargandoMenu,
    usuario
  };
};

const mapDispatchToProps = {
  mostrarModulo
};

Inicio.propTypes = {
  mostrarModulo: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Inicio);